import { Paths } from '../../../shared/paths';

export const supportBasePath = Paths.moderatorDashboard.support();
